module.exports = __webpack_public_path__ + "img/close-toaster.b08a8876.svg";